import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  DeactivateBudgetMatchParams,
  deactivateBudgetRouteProps,
} from 'src/navigation/routeProps'
import { RootState } from 'src/redux/createRootReducer'
import {
  selectCreditCardListModelsFromState,
  selectCreditCardPermissionsModelsFromState,
} from 'src/redux/selectors/data/creditCards.selectors'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'
import { ErrorDetailMap } from 'src/utils/error.utils'

export const selectCreditCardIdFromRoute = createSelector(
  [selectLocationFromState],
  (location) => {
    const mtch = matchPath<DeactivateBudgetMatchParams>(
      location.pathname,
      deactivateBudgetRouteProps,
    ) as match<DeactivateBudgetMatchParams>
    return mtch.params.id
  },
)

export const selectCreditCard = createSelector(
  [selectCreditCardListModelsFromState, selectCreditCardIdFromRoute],
  (creditCards, creditCardId) => {
    return creditCards[creditCardId] !== undefined
      ? creditCards[creditCardId]
      : undefined
  },
)

export const selectCreditCardPermissions = createSelector(
  [selectCreditCardPermissionsModelsFromState, selectCreditCardIdFromRoute],
  (creditCardPermissions, creditCardId) => {
    return creditCardPermissions[creditCardId] !== undefined
      ? creditCardPermissions[creditCardId]
      : undefined
  },
)

export const selectDeletingCreditCardFromState = (state: RootState): boolean =>
  state.app.deleteAccount.deletingCreditCard

export const selectTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.deleteAccount.topLevelError

export const selectErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined => state.app.deleteAccount.errorDetailMap
